import { Key } from 'react';

interface IAddressValidationProps {
  address1: string;
  address2: string;
  city: string;
  state: string|Key;
  zipCode: string;
}

interface IAddressValidation {
  address: {
    sugAddr2: string,
    sugAddr1: string,
    sugCity: string,
    sugState: string,
    sugZip4: string,
    sugZip5: string,
  };
  success: boolean;
}

const validateFail = {
  address: {
    sugAddr2: '',
    sugAddr1: '',
    sugCity: '',
    sugState: '',
    sugZip4: '',
    sugZip5: '',
  },
  success: false,
};

export const addressValidation = async ({
  address1,
  address2,
  city,
  state,
  zipCode,
}: IAddressValidationProps): Promise<IAddressValidation> => {
  const addressCheckReq = await fetch('/api/account/address/verifyAddress', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    body: JSON.stringify({
      addr1: address1,
      addr2: address2 || '',
      city: city,
      state: state,
      zip: zipCode,
    }),
  });
  const addressCheckRes = await addressCheckReq.json();
  // USPS api not reached at all
  if(addressCheckRes.success === false) {
    return validateFail;
  }
  
  const {
    Address1,
    Address2,
    City,
    State,
    Zip4,
    Zip5,
  } = addressCheckRes.data;
  return {
    address: {
      // swap addr1&2 for formatting
      sugAddr2: Address1 ? Address1[0] : '',
      sugAddr1: Address2[0],
      sugCity: City[0],
      sugState: State[0],
      sugZip4: Zip4[0],
      sugZip5: Zip5[0],
    },
    success: true,
  };
};
